import { API_URLS, customAxios } from "../config";

export const getSalesData = (payload) =>
  customAxios
    .post(API_URLS.getSalesData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getOtherIncomeDataOptions = (payload) =>
  customAxios
    .get(API_URLS.getOtherIncomeDataOptions, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postOtherIncomeData = (payload) =>
  customAxios
    .post(API_URLS.postOtherIncomeData + payload.merchant_id, payload.data)
    .then((res) => res?.data)
    .catch((error) => error);

export const postOtherIncomeEditData = (payload) =>
  customAxios
    .post(API_URLS.postOtherIncomeEditData + payload.id, payload.data)
    .then((res) => res?.data)
    .catch((error) => error);

export const getOrderPaymentsData = (payload) =>
  customAxios
    .post(API_URLS.getOrderPaymentsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getOrderPaymentsItemData = (payload) =>
  customAxios
    .get(API_URLS.getOrderPaymentsItemData + payload?.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getOrderPaymentsComponentData = (payload) =>
  customAxios
    .post(API_URLS.getOrderPaymentsComponentData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getOrderPaymentsBundleItemData = (payload) =>
  customAxios
    .post(API_URLS.getOrderPaymentsBundleItemData, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const getOrderPaymentsViewBillsData = (payload) =>
  customAxios
    .get(API_URLS.getOrderPaymentsViewBillsData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getOrderPaymentsBillsItemData = (payload) =>
  customAxios
    .post(API_URLS.getOrderPaymentsBillsItemData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getOrderPaymentsBillsComponentData = (payload) =>
  customAxios
    .post(API_URLS.getOrderPaymentsBillsComponentData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postOrderPaymentsPrintBill = (payload) =>
  customAxios
    .post(API_URLS.postOrderPaymentsPrintBill, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getRefundsData = (payload) =>
  customAxios
    .post(API_URLS.getRefundsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getBillData = (payload) =>
  customAxios
    .post(API_URLS.getBillData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getInnerMenuItemsData = (payload) =>
  customAxios
    .post(API_URLS.getInnerMenuItemsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getInnerComponentData = (payload) =>
  customAxios
    .post(API_URLS.getInnerComponentData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getVoidsData = (payload) =>
  customAxios
    .post(API_URLS.getVoidsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getDiscountsData = (payload) =>
  customAxios
    .post(API_URLS.getDiscountsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getTipsData = (payload) =>
  customAxios
    .post(API_URLS.getTipsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPromotionsData = (payload) =>
  customAxios
    .post(API_URLS.getPromotionsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const getPromotionsSalesData = (payload) =>
  customAxios
    .get(API_URLS.getPromotionsSalesData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getExpensesData = (payload) =>
  customAxios
    .post(API_URLS.getExpensesData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPaymentsData = (payload) =>
  customAxios
    .post(API_URLS.getPaymentsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getAddPaymentsFormData = (payload) =>
  customAxios
    .get(API_URLS.getAddPaymentsFormData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postAddPaymentsFormData = (payload) =>
  customAxios
    .post(API_URLS.postAddPaymentsFormData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getExpenseTypeData = (payload) =>
  customAxios
    .post(API_URLS.getExpenseTypeData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getInvoicesData = (payload) =>
  customAxios
    .post(API_URLS.getInvoicesData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPayTradeLiabilityData = (payload) =>
  customAxios
    .post(API_URLS.getPayTradeLiabilityData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPayOtherDebtData = (payload) =>
  customAxios
    .post(API_URLS.getPayOtherDebtData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getBuyAssetData = (payload) =>
  customAxios
    .post(API_URLS.getBuyAssetData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPaymentAccountData = (payload) =>
  customAxios
    .get(API_URLS.getPaymentAccountData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getAddAssetData = (payload) =>
  customAxios
    .get(API_URLS.getAddAssetData + payload.asset_account_id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postAddAssetData = (payload) =>
  customAxios
    .post(API_URLS.postAddAssetData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postDeleteAddAssetData = (payload) =>
  customAxios
    .post(API_URLS.postDeleteAddAssetData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getApLiabilityData = (payload) =>
  customAxios
    .post(API_URLS.getApLiabilityData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getViewPaymentData = (payload) =>
  customAxios
    .get(API_URLS.getViewPaymentData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getEditPaymentData = (payload) =>
  customAxios
    .get(API_URLS.getEditPaymentData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postEditPaymentData = (payload) =>
  customAxios
    .post(API_URLS.postEditPaymentData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getRejectedPaymentsData = (payload) =>
  customAxios
    .get(API_URLS.getRejectedPaymentsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPendingPaymentsData = (payload) =>
  customAxios
    .get(API_URLS.getPendingPaymentsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getSubmittedPaymentsData = (payload) =>
  customAxios
    .get(API_URLS.getSubmittedPaymentsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getApprovedPaymentsData = (payload) =>
  customAxios
    .get(API_URLS.getApprovedPaymentsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postApprovedPaymentsData = (payload) =>
  customAxios
    .post(API_URLS.postApprovedPaymentsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getFinancePayablesOutstanding = (payload) =>
  customAxios
    .get(API_URLS.getFinancePayablesOutstanding, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getFinanceApCreditNotes = (payload) =>
  customAxios
    .post(API_URLS.getFinanceApCreditNotes, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getApCreditNotesOption = (payload) =>
  customAxios
    .get(API_URLS.getApCreditNotesOption, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getApCreditNotesTaxPercentage = (payload) =>
  customAxios
    .get(API_URLS.getApCreditNotesTaxPercentage + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postApCreditNotesData = (payload) =>
  customAxios
    .post(API_URLS.postApCreditNotesData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getEditApCreditNotesData = (payload) =>
  customAxios
    .get(API_URLS.getEditApCreditNotesData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postCreditNotesAttachment = (payload) =>
  customAxios
    .post(API_URLS.postCreditNotesAttachment, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getFinanceAssets = (payload) =>
  customAxios
    .post(API_URLS.getFinanceAssets, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const downloadFinanceAssets = (payload) =>
  customAxios
    .get(API_URLS.downloadFinanceAssets, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const downloadFinanceVoucher = (payload) =>
  customAxios
    .get(API_URLS.downloadFinanceVoucher + payload?.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getFinanceVouchers = (payload) =>
  customAxios
    .post(API_URLS.getFinanceVouchers, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getFinanceVouchersList = (payload) =>
  customAxios
    .get(API_URLS.getFinanceVouchersList, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getFinanceBalanceToIncome = (payload) =>
  customAxios
    .get(API_URLS.getFinanceBalanceToIncome + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export default {
  getFinanceBalanceToIncome,
  downloadFinanceVoucher,
  getFinanceVouchers,
  getFinanceVouchersList,
  getFinanceAssets,
  downloadFinanceAssets,
  getEditApCreditNotesData,
  postCreditNotesAttachment,
  postApCreditNotesData,
  getApCreditNotesTaxPercentage,
  getApCreditNotesOption,
  getFinanceApCreditNotes,
  getFinancePayablesOutstanding,
  getSalesData,
  getOtherIncomeDataOptions,
  postOtherIncomeData,
  postOtherIncomeEditData,
  getOrderPaymentsData,
  getOrderPaymentsItemData,
  getOrderPaymentsComponentData,
  getOrderPaymentsBundleItemData,
  getOrderPaymentsViewBillsData,
  getOrderPaymentsBillsItemData,
  getOrderPaymentsBillsComponentData,
  postOrderPaymentsPrintBill,
  getRefundsData,
  getBillData,
  getInnerMenuItemsData,
  getInnerComponentData,
  getVoidsData,
  getDiscountsData,
  getTipsData,
  getPromotionsData,
  getPromotionsSalesData,
  getExpensesData,
  getPaymentsData,
  getAddPaymentsFormData,
  postAddPaymentsFormData,
  getExpenseTypeData,
  getInvoicesData,
  getPayTradeLiabilityData,
  getPayOtherDebtData,
  getBuyAssetData,
  getPaymentAccountData,
  getAddAssetData,
  postAddAssetData,
  postDeleteAddAssetData,
  getApLiabilityData,
  getViewPaymentData,
  getEditPaymentData,
  postEditPaymentData,
  getRejectedPaymentsData,
  getPendingPaymentsData,
  getSubmittedPaymentsData,
  getApprovedPaymentsData,
  postApprovedPaymentsData,
};
